import { GenericEntity } from './generic-entity.interface';

// Emitted on delete-button click; caller routes to its own delete flow without re-querying.
export interface EntityFormDeleteAction<T extends GenericEntity> {
  __action: 'delete';
  entity: T;
}

// Widening allows dynamic auxiliary fields (e.g. `modelId` on campaign creation).
export type EntityFormValue<T extends GenericEntity> = Partial<T> & Record<string, unknown>;

// submit | delete-sentinel | cancel (false).
export type EntityFormResult<T extends GenericEntity> = EntityFormValue<T> | EntityFormDeleteAction<T> | false;

export function isEntityFormDeleteAction<T extends GenericEntity>(
  result: EntityFormResult<T> | undefined,
): result is EntityFormDeleteAction<T> {
  return typeof result === 'object' && result !== null && '__action' in result && result.__action === 'delete';
}
